// Defaults and limits of the app's Senior Settings screen (utils/constants/common.ts there): what the
// app shows for a setting that was never saved, and what a switch restores when turned back on.
export const SENIOR_SETTINGS_DEFAULT = {
  blockUnknownNumber: false,
  volume: 0.8,
  brightness: 0.8,
  themeMode: 'LIGHT',
  flashlightOn: false,
  flashlightTimeoutMinutes: 2,
  screenTimeoutMinutes: 2,
  autoAnswerDelaySeconds: 10,
  fallDetectSensitivity: 3,
  inactivityTimeoutMinutes: 180,
  thresholdLowBattery: 15,
  dataRetentionDays: 7,
};

export const MAX_FALL_DETECT_SENSITIVITY_LEVEL = 5;
export const MAX_DATA_RETENTION_DAYS = 30;
export const SECONDS_PER_MINUTE = 60;
